import { useUserIdentities } from '@launcher/hooks/useUserIdentities';
import { filterSenderIdentities, getSortedIdentities } from '@utils/identities.util';
import { useMemo } from 'react';

export default function useDocumentIdentities(enabled = true) {
  const base = useUserIdentities(enabled);

  const data = useMemo(() => {
    if (!base.data) {
      return undefined;
    }

    return getSortedIdentities(filterSenderIdentities(base.data.list));
  }, [base.data]);

  return {
    ...base,
    data,
  };
}
